<template>
  <div class="item-data-cell">
    <span v-if="showBudgetPhase" class="budget-phase exchange">{{
      budget
    }}</span>

    <div
      v-else
      @click="!func || isTotalZero ? () => {} : customAction()"
      :class="!func || isTotalZero ? '' : 'total-info'"
    >
      <span v-if="isTotalZero" class="grey--text text--darken-1 italic-style">
        -
      </span>
      <strong v-else>{{ total }}</strong>
      <span
        v-if="!isTotalZero && showPercent"
        class="percentStyle grey--text text--darken-1"
      >
        ({{ percentOfTotal }}%)
      </span>
    </div>

    <div
      v-if="showZoom"
      class="indicator-pill zoom-pill"
      :class="!zoomFunc || isZoomCountZero ? '' : 'total-info'"
      @click="!zoomFunc || isZoomCountZero ? () => {} : zoomFunc()"
    >
      <v-icon x-small color="#1565c0">mdi-video</v-icon>
      {{ zoomCount }}
    </div>
    <div
      v-if="showVirtualMeeting"
      class="indicator-pill virtual-meeting-pill"
      :class="
        !virtualMeetingFunc || isVirtualMeetingCountZero ? '' : 'total-info'
      "
      @click="
        !virtualMeetingFunc || isVirtualMeetingCountZero
          ? () => {}
          : virtualMeetingFunc()
      "
    >
      <v-icon x-small color="#6a1b9a">mdi-account-group</v-icon>
      {{ virtualMeetingCount }}
    </div>
  </div>
</template>

<script>
// separe in a component
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    phase: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    showBudgetPhase: {
      type: Boolean,
      required: false,
      default: false
    },
    budget: {
      type: String,
      required: false,
      default: "-"
    },
    func: {
      type: Function,
      required: false
    },
    showPercent: {
      type: Boolean,
      required: false,
      default: false
    },
    showZoom: {
      type: Boolean,
      required: false,
      default: false
    },
    zoomCount: {
      type: Number,
      required: false,
      default: 0
    },
    zoomFunc: {
      type: Function,
      required: false
    },
    showVirtualMeeting: {
      type: Boolean,
      required: false,
      default: false
    },
    virtualMeetingCount: {
      type: Number,
      required: false,
      default: 0
    },
    virtualMeetingFunc: {
      type: Function,
      required: false
    }
  },
  computed: {
    isTotalZero() {
      return this.total === 0;
    },
    isZoomCountZero() {
      return this.zoomCount === 0;
    },
    isVirtualMeetingCountZero() {
      return this.virtualMeetingCount === 0;
    },
    percentOfTotal() {
      return this.getPercent(this.total, this.item.totalByContact);
    }
  },
  methods: {
    getPercent(value, total) {
      return ((value * 100) / total).toFixed(2);
    },
    customAction() {
      this.func();
    }
  }
};
</script>

<style>
.italic-style {
  font-style: italic;
}

.budget-phase {
  color: #1b5e20;
  font-style: italic;
}

.total-info {
  cursor: pointer;
}
.percentStyle {
  font-style: italic;
  font-size: 13px;
  font-size: smaller;
}
.exchange {
  font-size: 13px !important;
}

/* el wrapper padre (wrapperItemComertialReport) fuerza display:flex en fila
   sobre este div raíz vía scoping; se restaura el apilado vertical aquí */
.item-data-cell {
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 4px 0;
  width: 100%;
}

.indicator-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
}

.zoom-pill {
  color: #1565c0;
  background-color: #e3f2fd;
}

.virtual-meeting-pill {
  color: #6a1b9a;
  background-color: #f3e5f5;
}
</style>
